export default __webpack_public_path__ + "static/media/MAD.decbbde0.svg";